import $ from 'jquery';
import EmblaCarousel from 'embla-carousel';

class CarouselEmbla { 
    constructor() {

    }

    init() {
        this.startCarousel();
    }

    startCarousel() {
        const emblaNodes = $('.embla');
        let i = 0;
        if (emblaNodes.length > 0) {
            emblaNodes.each((index, embla) => {
                if (typeof (embla) !== 'undefined') {
                    let dotNodes = [];
                    const options = { loop: true, align: 'start' };
                    i += 1;
                    const emblaApi = EmblaCarousel(embla, options);

                    const dotsNode = embla.querySelector('.embla__dots');
                    dotsNode.innerHTML = emblaApi
                        .scrollSnapList()
                        .map(() => '<button class="embla__dot" type="button"></button>')
                        .join('');

                    const scrollTo = (index) => {
                        emblaApi.scrollTo(index);
                    };

                    const scrollPrev = () => {
                        emblaApi.scrollPrev();
                    };

                    const scrollNext = () => {
                        emblaApi.scrollNext();
                    };

                    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
                    dotNodes.forEach((dotNode, index) => {
                        dotNode.addEventListener('click', () => scrollTo(index), false);
                    });


                    const prevBtn = embla.querySelector('.embla__button--prev');
                    const nextBtn = embla.querySelector('.embla__button--next');

                    prevBtn.addEventListener('click', scrollPrev, false);
                    nextBtn.addEventListener('click', scrollNext, false);

                    const toggleDotBtnsActive = () => {
                        const previous = emblaApi.previousScrollSnap();
                        const selected = emblaApi.selectedScrollSnap();
                        dotNodes[previous].classList.remove('active');
                        dotNodes[selected].classList.add('active');
                    };

                    emblaApi
                        .on('init', toggleDotBtnsActive)
                        .on('reInit', toggleDotBtnsActive)
                        .on('select', toggleDotBtnsActive);
                }
            });
        }
    }
}

export default CarouselEmbla;

$(() => {
	const carousel = new CarouselEmbla();
	carousel.init();
});